export default "__VITE_ASSET__DNqMjgWG__"